import Link from 'next/link';

import ContactAdvisorLink from '@/components/shared/ContactAdvisorLink';

type toolTipProps = {
  handleFocusLink?: () => void;
  handleBlurLink?: (flag?: boolean) => void;
};

export const GradesToolTip = ({ handleFocusLink, handleBlurLink }: toolTipProps) => (
  <div className="">
    <span>
      <div
        data-testid="grades-tooltip-text1"
        className="font-sans text-xs font-normal leading-[1.5em] text-spblack"
      >
        UMGC has four grading methods: standard, pass/fail, satisfactory/D/fail, and audit. Standard
        is most common. Please note, if your course is transferred from another institution, it may
        show a grade of T for Transfer, or A, B, C, D, or F. Transfer credit grades are not included
        in the calculation of your GPA.
      </div>
      <div
        data-testid="grades-tooltip-text2"
        className="mt-2 font-sans text-xs font-normal leading-[1.5em] text-spblack"
      >
        A: Outstanding, 4 grade points; B: Superior, 3 grade points; C: Good, 2 grade points; D:
        Substandard, 1 grade points; F: Failure, 0 grade points; AU: Audit; FN: Failure for
        Nonattendance; G: Grade Under Review; I: Incomplete; P: Passing; S: Satisfactory; T:
        Transfer; U: Unsatisfactory; W: Withdrawal;
      </div>
      <div className="mt-2 flex items-center font-sans text-xs leading-[1.5em] text-spblack">
        If you have questions, &nbsp;
        <ContactAdvisorLink
          tabIndex={0}
          className="flex items-center gap-1 text-xs font-bold leading-[1.5em] text-spblue underline hover:underline focus:underline"
          data-testid="graders-tooltip-contact-advisor-link"
          onFocus={handleFocusLink} // Open tooltip when focusing on icon
          onBlur={() => handleBlurLink && handleBlurLink()}
          iconClassName="!text-base !ml-0"
        />
        .
      </div>
    </span>
  </div>
);

export const CreditsToolTip = ({ handleFocusLink, handleBlurLink }: toolTipProps) => (
  <div>
    <span className="font-sans text-xs font-normal leading-[1.5em] text-spblack">
      To learn which courses are accepted by UMGC and their equivalencies, see{' '}
      <Link
        href="/academicRecords/transferCredits"
        className="font-sans font-bold text-spblue underline hover:underline focus:underline"
        tabIndex={0}
        onFocus={handleFocusLink}
        onBlur={() => handleBlurLink && handleBlurLink(false)}
      >
        Transfer Credit Report
      </Link>
      . For more information on how your transfer credits apply to your degree, go to your{' '}
      <Link
        href="/degreePlanning/aar"
        className="font-sans font-bold text-spblue underline hover:underline focus:underline"
        tabIndex={0}
        onFocus={handleFocusLink}
        onBlur={() => handleBlurLink && handleBlurLink()}
      >
        AAR
      </Link>
      .
    </span>
  </div>
);

export const GradesPointsToolTip = () => (
  <div className="!z-[999]">
    <span>
      <div
        data-testid="grades-tooltip-text1"
        className="font-sans text-xs font-normal leading-[1.5em] text-spblack"
      >
        Grade points (or quality points) are used to calculate your GPA. Each letter grade is
        assigned a numerical value, A=4.0, B=3.0, C=2.0, D=1.0, and F=0. That value multiplied by
        the number of credits for the course provides the grade point for that course.
      </div>
    </span>
  </div>
);

export const ToDoStatusTooltip = () => (
  <div className="!z-[999]">
    <span>
      <div
        data-testid="todo-status-tooltip-text1"
        className="font-sans text-xs font-normal leading-[1.5em] text-spblack"
      >
        Initiated status indicates To Dos have been entered for your account and activation is
        pending. Active status indicates To Dos are currently live for your account and need to be
        resolved.
      </div>
    </span>
  </div>
);

export const TransferCreditTestComponentTooltip = () => (
  <div className="!z-[999]">
    <span>
      <div className="font-sans text-lg font-normal leading-[1.5em] text-spblack">
        Test component is the test module that you took.
      </div>
    </span>
  </div>
);
